<br>
<h3>Project Sampling</h3>
<p class="w-50">
  Enable and customize sequential review stages (Overread) for this project. All project tasks become eligible for
  review when settings are applied.
</p>
<br>
<div class="container flex-gap">
  <div class="grid">
    <span class="grid__header"></span>
    <div class="container justify-center">
      <p>Compliant</p>
      <div class="icon">
        <app-icon iconStyle="fal" iconName="info-circle" [pTooltip]="'Compliant = All numerators are compliant for the chase/measure.'" [tooltipPosition]="'top'"></app-icon>
      </div>
    </div>
    <div class="container justify-center">
      <p>Partial Compliant</p>
      <div class="icon">
        <app-icon iconStyle="fal" iconName="info-circle" [pTooltip]="'Partial Compliant = At least one numerator is medical record compliant at the chase/measure level,  however other numerators are non-compliant for the same chase/measure.'" [tooltipPosition]="'top'"></app-icon>
      </div>
    </div>
    <div class="container justify-center">
      <p>Non-Compliant</p>
      <div class="icon">
        <app-icon iconStyle="fal" iconName="info-circle" [pTooltip]="'Non-Compliant = At least one numerator is non-compliant for the chase/measure.'" [tooltipPosition]="'top'"></app-icon>
      </div>
    </div>
    <div class="container justify-center">
      <p>Exclusion</p>
      <div class="icon">
        <app-icon iconStyle="fal" iconName="info-circle" [pTooltip]="'Exclusion = Chase/Measure contains an exclusion for the measure in the appropriate timeframe.'" [tooltipPosition]="'top'"></app-icon>
      </div>
    </div>
    <div class="container grid__header">
      <p>Overread I</p>
      <div class="icon">
        <app-icon iconStyle="fal" iconName="info-circle" [pTooltip]="'This setting initiates review on first-pass coding.'" [tooltipPosition]="'top'"></app-icon>
      </div>
      <form-factory class="input-switch" [formGroup]="activeFormGroup.formGroup" [model]="activeFormGroup.models[0]"></form-factory>
    </div>
    <ng-container *ngFor="let control of getControls(formOverread.formGroup); let i = index; trackBy: trackByIndex">
      <div class="container justify-center">
        <form-factory class="input" [formGroup]="formOverread.formGroup" [model]="formOverread.models[i]"></form-factory>
      </div>
    </ng-container>
    <div class="container grid__header">
      <p>Overread II</p>
      <div class="icon">
        <app-icon iconStyle="fal" iconName="info-circle" [pTooltip]="'This setting initiates secondary review.'" [tooltipPosition]="'top'"></app-icon>
      </div>
      <form-factory class="input-switch" [formGroup]="active2FormGroup.formGroup" [model]="active2FormGroup.models[0]"></form-factory>
    </div>
    <ng-container *ngFor="let control of getControls(formOverread2.formGroup); let i = index; trackBy: trackByIndex">
      <div class="container justify-center">
        <form-factory class="input" [formGroup]="formOverread2.formGroup" [model]="formOverread2.models[i]"></form-factory>
      </div>
    </ng-container>
  </div>
</div>
